import React from 'react';
import classNames from 'classnames';
import { SocketedButton } from '@deephaven/components';
import "./ChartColumnSelectorOverlay.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ChartColumnSelectorOverlay(_ref) {
  var columns = _ref.columns,
    onColumnSelected = _ref.onColumnSelected,
    _onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  return /*#__PURE__*/_jsx("div", {
    className: "chart-panel-overlay chart-column-selector-overlay",
    children: /*#__PURE__*/_jsxs("div", {
      className: classNames('chart-panel-overlay-content'),
      children: [/*#__PURE__*/_jsx("div", {
        className: "info-message",
        children: "This plot requires a filter control to be added to the layout or a table link to be created on the following columns:"
      }), /*#__PURE__*/_jsx("div", {
        className: "waiting-column-select-list",
        children: columns.map(column => /*#__PURE__*/_jsx(SocketedButton, {
          className: classNames('btn-chart-column-selector', ChartColumnSelectorOverlay.makeButtonClassName(column.name)),
          onClick: () => onColumnSelected(column.name),
          onMouseEnter: () => {
            _onMouseEnter === null || _onMouseEnter === void 0 || _onMouseEnter(column);
          },
          onMouseLeave: onMouseLeave,
          disabled: !column.isValid,
          isLinked: column.isActive,
          children: column.name
        }, column.name))
      })]
    })
  });
}
ChartColumnSelectorOverlay.makeButtonClassName = columnName => "btn-chart-column-selector-".concat(columnName);
export default ChartColumnSelectorOverlay;
//# sourceMappingURL=ChartColumnSelectorOverlay.js.map